import { setStoreChosenLanguage } from '../../../features/storeLocale/slice';

export const changeStoreChosenLanguage = chosenLanguage => dispatch => dispatch(setStoreChosenLanguage({ storeChosenLanguage: chosenLanguage }));